<template>
  <div v-if="configData.Text">
    <NuxtLink
      :to="configData.Url"
      external
      :target="configData.Target"
      :aria-label="configData.AriaLabel"
    >
      {{ configData.Text }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Text: string;
    AriaLabel: string;
    Url: string;
    Target: '_blank' | '';
  };
}

defineProps<Props>();
</script>

<style scoped></style>
